<div class="row">
  <div class="col-6 col-md-4 col-lg-3 mb-4" *ngFor="let i of [1,2,3,4,5,6,7,8]">
    <div class="card">
      <div class="placeholder-glow">
        <div class="placeholder col-12" style="height: 200px;"></div>
      </div>
      <div class="card-body">
        <div class="placeholder-glow">
          <div class="placeholder col-12 mb-2"></div>
          <div class="placeholder col-8"></div>
        </div>
      </div>
    </div>
  </div>
</div>
